import React, { useReducer } from 'react';
import { useMutation } from '@apollo/client';
import Steps from '../Common/components/Steps';
import { questionnaireReducer } from '../Common';
import { insertQuestionnaireMutation } from './mutations';
import { CustomBackdrop } from '@blumtechgroup/blum-react-core-components';

interface Props {
  handleFinish: () => void;
}

const CreateDansFundQuestionnaireComponent = ({ handleFinish }: Props): React.ReactElement => {
  const [questionnaire, dispatchQuestionnaire] = useReducer(questionnaireReducer, {
    name: '',
    send_to: '',
    questions: [],
  });

  const [insertQuestionnaire, { loading: saving }] = useMutation(insertQuestionnaireMutation, { onCompleted: handleFinish });

  const handleSave = async () => {
    await insertQuestionnaire({
      variables: {
        object: {
          ...questionnaire,
        },
      },
    });
  };

  return (
    <>
      <Steps completeLabel="Create" questionnaire={questionnaire}
             dispatch={dispatchQuestionnaire} handleSave={handleSave} />
      {saving && <CustomBackdrop label="Loading" />}
    </>
  );
};

export default CreateDansFundQuestionnaireComponent;
